export const atlassianJiraIssueEditorSelector = state => state.ui.atlassianJiraIssueEditor;
